import React, {Component} from 'react';
import PropTypes from 'prop-types';

export default class CancelTripModalRefund extends Component {
    static propTypes = {
        message: PropTypes.string.isRequired,
        showVasMessage: PropTypes.bool,
        title: PropTypes.string.isRequired,
        vasMessage: PropTypes.string,
    };

    static defaultProps = {
        showVasMessage: false,
    };

    render() {
        const {message, showVasMessage, title, vasMessage} = this.props;

        return (
            <div className="CancelTrip__step">
                <h3 className="CancelTrip__title">{title}</h3>
                <div className="CancelTrip__text">{message}</div>
                {showVasMessage && (
                    <div className="CancelTrip__text">{vasMessage}</div>
                )}
            </div>
        );
    }
}
